import { render, staticRenderFns } from "./PlgBrandItem.vue?vue&type=template&id=069b3c63&scoped=true&"
import script from "./PlgBrandItem.vue?vue&type=script&lang=ts&"
export * from "./PlgBrandItem.vue?vue&type=script&lang=ts&"
import style0 from "./PlgBrandItem.vue?vue&type=style&index=0&id=069b3c63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069b3c63",
  null
  
)

export default component.exports